import { t } from "i18next";
import { useEffect, useState } from "react";
import { Alert, Modal, Table } from "react-bootstrap";
import { LoadingSpinner } from "../../../general/loading-spinner";
import moment from 'moment';
import { LinesChart } from "../../../charts/lines-chart";
import { getAthleteAcitivityDetails } from "../../../../services/athlete";

interface CoachReportsAcvtivityViewProps {
    userId: string;
    activityId: string;
    onClose: CallableFunction;
}

export function CoachReportsAcvtivityView(props: CoachReportsAcvtivityViewProps) {    
    const [loaded, setLoaded] = useState(false);
    const [activityDetails, setActivityDetails] = useState<any>();

    useEffect(() => {
        getAthleteAcitivityDetails(props.userId, props.activityId)
            .then(response => {
                setActivityDetails(response.data);
                setLoaded(true);
            });
    }, []);

    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="activity-details-container" show={ true }
            onHide={ handleClose } size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Activity details") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && <LoadingSpinner />}
                { loaded && activityDetails.summary === undefined &&
                    <Alert key={'info'} variant={'info'}>
                        { t("This activty has no details.") }
                    </Alert>
                }
                { loaded && activityDetails.summary !== undefined &&
                    <div className="activity-details">
                        <h2>{ activityDetails.summary.activityName }</h2>
                        <Table size="sm">
                            <tbody>
                                <tr>
                                    <td>{ t("Start time") }</td>
                                    <td>{ moment(new Date((activityDetails.summary.startTimeInSeconds + activityDetails.summary.startTimeOffsetInSeconds)*1000)).format('DD/MM/Y H:mm') }</td>
                                </tr>
                                <tr>
                                    <td>{ t("Duration") }</td>
                                    <td>{ moment.utc(activityDetails.summary.durationInSeconds*1000).format('HH:mm:ss') }</td>
                                </tr>
                                <tr>
                                    <td>{ t("Heart Rate") }</td>
                                    <td>
                                        { t("Average") }: { activityDetails.summary.averageHeartRateInBeatsPerMinute } { t("bpm") }<br />
                                        { t("Maximum") }: { activityDetails.summary.maxHeartRateInBeatsPerMinute } { t("bpm") }
                                    </td>
                                </tr>
                                <tr>
                                    <td>{ t("Speed") }</td>
                                    <td>
                                        { t("Average") }: { activityDetails.summary.averageSpeedInMetersPerSecond.toFixed(2) } { t("m/s") }<br />
                                        { t("Maximum") }: { activityDetails.summary.maxSpeedInMetersPerSecond.toFixed(2) } { t("m/s") }
                                    </td>
                                </tr>
                                <tr>
                                    <td>{ t("Active calories") }</td>
                                    <td>
                                        { t("Average") }: { activityDetails.summary.activeKilocalories } { t("kcal") }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        { activityDetails.samples.length > 0 &&
                            <LinesChart
                                title={ t("Heart Rate") }
                                category={ activityDetails.samples.map((s: any) => {
                                   return moment.utc(s.startTimeInSeconds*1000).format('HH:mm:ss')
                                })} 
                                data={ activityDetails.samples.map((s: any) => {
                                    return s.heartRate;
                                })}
                                units={ t("bpm") }
                                color={ '#34B689' }
                                yAxisType="value"
                                showSeriesLabel={ true }
                            />
                        }
                        { activityDetails.samples.length > 0 &&
                            <LinesChart
                                title={ t("Speed") }
                                category={ activityDetails.samples.map((s: any) => {
                                   return moment.utc(s.startTimeInSeconds*1000).format('HH:mm:ss')
                                })} 
                                data={ activityDetails.samples.map((s: any) => {
                                    return s.speedMetersPerSecond;
                                })}
                                units={ t("m/s") }
                                color={ '#FABF48' }
                                yAxisType="value"
                                showSeriesLabel={ true }
                            />
                        } 
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}